<template>
  <div class="miya-developerAPI">
    <h1 class="title1 fontSH">{{$t('menu.m6')}}</h1>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  mounted () {  
    this.getData()
  },
  methods: {
    getData () {
    }
  },
  beforeDestroy () {
  },
  watch: {
    language () {
      this.getData()
    },
  },
  components: {}
}
</script>
<style scoped lang="stylus">
.miya-developerAPI
  padding 40px 
  position relative
  .title1
    color $c1
    font-size 28px
    fontWeight()
    margin 10px 0 32px 0
</style>